import moment from 'moment'
import {sacList, anomalieList, evenementDetailList, evenementEtatList, evenementList} from '../const'
import state from '../store/state'

function getMateriel (id_materiel) {

  let materiel = null
  state.materiels.data.forEach((mat) => {
    if (mat.id === id_materiel) {
      materiel = mat
    }
  })
  return materiel
}

export function arrondissement (arr) {
  var _arr = parseInt(arr, 10)
  if (_arr === 1) {
    return 'Dijon'
  } else if (_arr === 2) {
    return '2ème arrondissement'
  }
  return `arrondissement inconnu (${arr})`
}

export function arrondissementName (id_arrondissement) {
  let arrondissement = state.currentVille.arrondissements.find(arr => arr.id === id_arrondissement)
  return arrondissement ? arrondissement.nom : ''
}

export function allArrondissementName (id_arrondissement) {

  let arrondissement = state.allArrondissements.data.find(arr => arr.id === id_arrondissement)
  return arrondissement ? arrondissement.nom : ''
}

export function allVillesName (id_ville) {
  let ville = state.villes.data.find(arr => arr.id === id_ville)
  return ville ? ville.nom : ''
}

export function profileName (authorities) {
  console.log('authorities => ', authorities)
  if (authorities.filter(u => u.jwtRole === 'COLLECTIVITY_USER').length > 0) {
    return 'Collectivité'
  } else {
    return 'Maîtrise'
  }
}

export function secteurName (id_secteur) {
  let secteur = state.secteurs.data.find(arr => arr.id === id_secteur)
  return secteur ? secteur.nom : ''
}

export function cantonnierName (id_cantonnier) {
  console.log('demande all data  => ', state.cantonniers.allData)
  console.log('demande cantonnier id  => ', id_cantonnier)
  if (state.cantonniers.allData) {
    let cantonnier = state.cantonniers.allData.find(canto => canto.id === id_cantonnier)
    return cantonnier ? cantonnier.nom + ', ' + cantonnier.prenom : ''
  }
}

export function maitriseName (id_maitrise) {
  let maitrise = state.maitrises.allData.find(mait => mait.id === id_maitrise)
  return maitrise ? maitrise.nom + ', ' + maitrise.prenom : ''
}

export function materielType (type) {
  var _type = parseInt(type, 10)

  switch (_type) {
    case 1 :
      return 'Chariot'
    case 2 :
      return 'Trottinette'
    case 3 :
      return 'Laveuse électrique'
    case 4 :
      return 'Goupil'
    case 5 :
      return 'Triporteur électrique'
    case 6 :
      return 'Scooter électrique'
    case 7 :
      return 'Glutton'
    case 8 :
      return 'Trottinette électrique'
  }

  return `type inconnu (${type})`
}

export function materielTypeV2 (id_materiel) {

  const materiel = getMateriel(id_materiel)

  console.log('id materiel => ', id_materiel)
  console.log('materiel => ', materiel)
  switch (materiel.materielType) {
    case 'Chariot' :
      return 'Chariot'
    case 'Trottinette' :
      return 'Trottinette'
    case 'Laveuse électrique' :
      return 'Laveuse électrique'
    case 'Goupil' :
      return 'Goupil'
    case 'Triporteur électrique' :
      return 'Triporteur électrique'
    case 'Scooter électrique' :
      return 'Scooter électrique'
    case 'Glutton' :
      return 'Glutton'
    case 'Trottinette électrique' :
      return 'Trottinette électrique'
    case 'Poids Lourd' :
      return 'Poids Lourd'
  }

  return `type inconnu (${materiel.materielType})`
}

export function remonteeType (remontee) {
  switch (remontee) {
    case 'DEBUT_DE_SERVICE' :
      return 'Debut de service'
    case 'DEBUT_DE_SECTEUR' :
      return 'Debut de secteur'
    case 'FIN_DE_SECTEUR' :
      return 'Fin de secteur'
    case 'FIN_DE_SERVICE' :
      return 'Fin de service'
    case 'PAUSE' :
      return 'Pause'
    case 'REPRISE' :
      return 'Reprise'
    case 'SUIVI_GPS' :
      return 'Suivi GPS'
  }
  return 'inconnu'
}

export function materielName (id_materiel) {
  const materiel = getMateriel(id_materiel)
  return materiel.nom
}

export function getMaterielFromDeclaration (id_tournee) {
  //console.log("state.mapV2.result.infoDeclarations => " , state.map.result.infoDeclarations)
  // console.log("id_tournee => " , id_tournee)
  const tournee = state.map.result.infoDeclarations.find(t => t.tournee === id_tournee)
  // console.log("my tournee => " , tournee)
  return materielName(tournee.materiel)

}

export function collecteType (type) {

  switch (type) {
    case 'CORBEILLE' :
      return 'Corbeille'
    case 'CANIBOX' :
      return 'Canibox'
  }

  return `type inconnu (${type})`
}

export function materielPicto (type) {
  var _type = parseInt(type, 10)
  var before = 'static/img/icon-'
  var after = '.svg'
  switch (_type) {
    case 1 :
      return before + 'chariot' + after
    case 2 :
      return before + 'trottinette' + after
    case 3 :
      return before + 'laveuse' + after
    case 4 :
      return before + 'goupil' + after
    case 5 :
      return before + 'triporteur' + after
    case 6 :
      return before + 'scooter' + after
    case 7 :
      return before + 'glutton.png'
    case 8 :
      return before + 'trottinette' + after
  }

  return before + 'chariot' + after
}

export function materielPictoV2 (id_materiel) {

  const materiel = getMateriel(id_materiel)

  // console.log('l materiel => ', id_materiel)

  var before = 'static/img/icon-'
  var after = '.svg'
  switch (materiel.materielType) {
    case 'Chariot' :
      return before + 'chariot' + after
    case 'Trottinette' :
      return before + 'trottinette' + after
    case 'Laveuse électrique' :
      return before + 'laveuse' + after
    case 'Poids Lourd' :
      return before + 'laveuse' + after
    case 'Goupil' :
      return before + 'goupil' + after
    case 'Triporteur électrique' :
      return before + 'triporteur' + after
    case 'Scooter électrique' :
      return before + 'scooter' + after
    case 'Glutton' :
      return before + 'glutton.png'
    case 'Trottinette électrique' :
      return before + 'trottinette' + after
  }
}

export function genreType (type) {
  switch (type.toLowerCase()) {
    case 'pause' :
      return 'Pause'
    case 'reprise' :
      return 'Reprise'
    case 'debut_de_secteur' :
      return 'Début de secteur'
    case 'fin_de_secteur' :
      return 'Fin de secteur'
    case 'debut_de_service' :
      return 'Début de service'
    case 'fin_de_service' :
      return 'Fin de service'
    case 'suivi_gps' :
      return 'Suivi GPS'
    case 'anomalie' :
      return 'Anomalie'
    case 'depot_sac' :
      return 'Sac'
  }
  return 'Inconnu'
}

export function genrePicto (type) {
  return 'static/img/' + type.toLowerCase() + '.svg'
}

export function evenementType (evenement) {

  console.log('deb-eve => ', evenement)
  var mainlist = Object.assign(anomalieList(), sacList(), evenementList())
  var detailList = evenementDetailList()
  var etatList = evenementEtatList()

  // Si aucun type principal renseigné => inconnu
  if (!evenement.type) {
    return 'Anomalie inconnue'
  }

  // Si existe un détail
  if (evenement.detailType) {
    // Si autre => recup main
    if (evenement.detailType.toLowerCase() === 'autre') {
      var label = 'Autre ' + getLabel(evenement.type, mainlist).toLowerCase()
      // Sinon => recup détail
    } else {
      label = getLabel(evenement.detailType, detailList)
    }
  } else {
    label = getLabel(evenement.type, mainlist)
  }

  function getLabel (type, list, placeholder) {
    // placeholder = placeholder || 'Événement'
    let compareType = (list[type] !== undefined) ? type : type.toLowerCase()
    return list[compareType]
  }

  return label
}

export function prettyDate (date) {
  const dateTime = new Date(date)
  return dateTime.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})
}

export function prettyTimeStamp (date) {
  const dateTime = new Date(date * 1000)
  return dateTime.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})
}

export function prettyFullDate (date) {
  if (date !== undefined && date !== null) {
    return moment(new Date(date)).format('DD/MM/YYYY HH:mm')
  } else {
    return '-'
  }
}

export function prettyDuration (duration) {
  var m = moment.duration(duration)
  var h = m.hours()
  var mn = m.minutes()
  return (h.toString().length === 1 ? '0' : '') + h + 'h' + (mn.toString().length === 1 ? '0' : '') + mn
}

export function returnCity (maitrise) {
  if (maitrise.ville_id) {
    switch (maitrise.ville_id) {
      case 1:
        return 'Marseille'
      case 2:
        return 'Bordeaux'
      case 3:
        return 'Reims'
      case 4:
        return 'Lyon'
      case 5:
        return 'Dijon'
      case 6:
        return 'Creil'
      case 7:
        return 'Lyon métropole'
      case 8:
        return 'La ciotat'
    }
  } else {
    return 'Marseille'
  }
}

export function returnProfile (maitrise) {
  if (maitrise.is_collectivity_profile === 'true') {
    return 'Collectivité'
  } else {
    return 'Maîtrise'
  }
}




// WEBPACK FOOTER //
// ./src/filters/index.js